/**
 * CompanyRegistry API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { getSupportedCountries, searchCompanyRegistry } from "../generated/company-registry/company-registry";

import { wrapMethod } from "./utils";

export const companyRegistry = {
  /** @see searchCompanyRegistry */
  searchCompanyRegistry: wrapMethod(searchCompanyRegistry),

  /** @see getSupportedCountries */
  list: wrapMethod(getSupportedCountries),
} as const;

export type CompanyRegistryApi = typeof companyRegistry;
